/* eslint-disable react/prop-types */
import React from "react";

function BtnClose({ isModal }) {
  return (
    <svg
      width={isModal ? "20" : "26"}
      height={isModal ? "20" : "26"}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0007 0.083374C10.3444 0.083374 0.0839844 10.3438 0.0839844 23C0.0839844 35.6563 10.3444 45.9167 23.0007 45.9167C35.6569 45.9167 45.9173 35.6563 45.9173 23C45.9173 10.3438 35.6569 0.083374 23.0007 0.083374ZM30.7236 18.223C31.1031 17.83 31.313 17.3038 31.3083 16.7575C31.3036 16.2113 31.0845 15.6888 30.6982 15.3025C30.3119 14.9162 29.7894 14.6971 29.2432 14.6924C28.6969 14.6876 28.1707 14.8976 27.7777 15.2771L23.0007 20.0542L18.2236 15.2771C18.0314 15.0781 17.8015 14.9194 17.5473 14.8102C17.2932 14.7011 17.0198 14.6436 16.7432 14.6412C16.4665 14.6388 16.1922 14.6915 15.9362 14.7962C15.6801 14.901 15.4475 15.0557 15.2519 15.2513C15.0563 15.4469 14.9016 15.6795 14.7969 15.9356C14.6921 16.1916 14.6394 16.4659 14.6418 16.7425C14.6442 17.0192 14.7017 17.2925 14.8109 17.5467C14.92 17.8009 15.0788 18.0308 15.2777 18.223L20.0548 23L15.2777 27.7771C15.0788 27.9693 14.92 28.1992 14.8109 28.4534C14.7017 28.7075 14.6442 28.9809 14.6418 29.2575C14.6394 29.5342 14.6921 29.8085 14.7969 30.0645C14.9016 30.3206 15.0563 30.5532 15.2519 30.7488C15.4475 30.9444 15.6801 31.0991 15.9362 31.2038C16.1922 31.3086 16.4665 31.3613 16.7432 31.3589C17.0198 31.3565 17.2932 31.299 17.5473 31.1898C17.8015 31.0807 18.0314 30.9219 18.2236 30.723L23.0007 25.9459L27.7777 30.723C28.1707 31.1025 28.6969 31.3124 29.2432 31.3077C29.7894 31.3029 30.3119 31.0838 30.6982 30.6976C31.0845 30.3113 31.3036 29.7888 31.3083 29.2425C31.313 28.6963 31.1031 28.17 30.7236 27.7771L25.9465 23L30.7236 18.223Z"
        fill="white"
      />
    </svg>
  );
}

export default BtnClose;
